module.exports = Promise.resolve("b66acffc8239ff24");